<div class="warning-banner">
  <span class="banner-title">{{ bannerTitle }}</span>
  <div class="d-flex flex-column gap-2">
    <div>{{ bannerDescription }}</div>
    <div i18n>
      You can view the requested changes
      <button
        type="button"
        class="no-style-button primary-paddingless-text-button"
        aria-label="View the requested changes"
        i18n-aria-label
        (click)="goToSubmission.emit()">
        here</button
      >.
    </div>
  </div>
</div>
